import { Link } from "react-router-dom";
export const linkHelper = ({ url, title, target, cls }, index, length) => {
  return url?.startsWith("https") || url?.startsWith("http") ? (
    <a href={url} target={target} className={cls} key={index}>
      {title}
      {index < length - 1 ? ", " : ""}
    </a>
  ) : (
    <Link to={url} className={cls} key={index}>
      {title}
    </Link>
  );
};
